<template>
  <div class="bf-util">
    <div class="bf-util__card bf-card">
      <img
        src="/img/brand/bindfy_logo_new_purple.png"
        alt="Bindfy"
        class="bf-util__logo"
      />

      <div class="bf-util__code">404</div>

      <h4 class="bf-util__title">
        Ops!! A página que você está procurando não existe!
      </h4>
      <p class="bf-util__text">
        A página que você está procurando pode ter sido removida, teve seu nome
        alterado ou está temporariamente indisponível.
      </p>

      <router-link class="bf-btn bf-util__btn" to="/">
        <i class="ri-arrow-left-line"></i>
        Voltar para o Dashboard
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorPage",
  components: {},
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.bf-util {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  &__card {
    width: 100%;
    max-width: 460px;
    padding: 40px 36px;
    text-align: center;
  }

  &__logo {
    height: 40px;
    width: auto;
    margin-bottom: 22px;
  }

  &__code {
    font-size: 56px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    background: var(--brand-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text);
    margin: 0 0 12px;
  }

  &__text {
    font-size: 13.5px;
    line-height: 1.6;
    color: var(--text2);
    margin: 0 auto 26px;
    max-width: 360px;
  }

  &__btn {
    justify-content: center;
    padding: 11px 24px;
  }
}

@media (max-width: 767px) {
  .bf-util__card {
    padding: 32px 22px;
  }
}
</style>
